import { IAppState } from '../../../AppModulesWrapper';

import { EPaymentPeriod } from '../../repositories/monolith-python/entities/offer/BargainTermsSchema';

export function selectPaymentPeriod(state: IAppState): EPaymentPeriod | null | undefined {
  const { offer } = state.servicePickerWidget;

  return offer.bargainTerms.paymentPeriod;
}
